import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductXProductModifier } from "src/models/Products/ProductModifier.models";

interface ProductXProductModifierState {
  productXProductModifiers: IProductXProductModifier[];
  productXProductModifierToEdit: IProductXProductModifier | null;
}

const initialState: ProductXProductModifierState = {
  productXProductModifiers: [],
  productXProductModifierToEdit: null,
};

const ProductXProductModifierSlice = createSlice({
  name: "ProductXProductModifier",
  initialState,
  reducers: {
    setProductXProductModifierList: (state, action: PayloadAction<IProductXProductModifier[]>) => {
      state.productXProductModifiers = action.payload;
    },
    concatProductXProductModifierList: (state, action: PayloadAction<IProductXProductModifier[]>) => {
      state.productXProductModifiers = [...state.productXProductModifiers.concat(action.payload)];
    },
    setProductXProductModifierToEdit: (state, action: PayloadAction<IProductXProductModifier | null>) => {
      state.productXProductModifierToEdit = action.payload;
    },
    addProductXProductModifier: (state, action: PayloadAction<IProductXProductModifier>) => {
      state.productXProductModifiers.push(action.payload);
    },
    updateProductXProductModifier: (state, action: PayloadAction<IProductXProductModifier>) => {
      const index = state.productXProductModifiers.findIndex(
        item => item.productXProductModifierId === action.payload.productXProductModifierId
      );
      if (index !== -1) state.productXProductModifiers[index] = action.payload;
    },
    deleteProductXProductModifier: (state, action: PayloadAction<string>) => {
      state.productXProductModifiers = state.productXProductModifiers.filter(
        item => item.productXProductModifierId !== action.payload
      );
    },
  },
});

export const {
  setProductXProductModifierList,
  concatProductXProductModifierList,
  setProductXProductModifierToEdit,
  addProductXProductModifier,
  updateProductXProductModifier,
  deleteProductXProductModifier,
} = ProductXProductModifierSlice.actions;

export default ProductXProductModifierSlice.reducer;
